import type { SVGProps } from "react";

export type IconName =
  | "home"
  | "chart"
  | "garage"
  | "plus"
  | "bell"
  | "clock"
  | "user"
  | "user-plus"
  | "fuel"
  | "filter"
  | "pin"
  | "calendar"
  | "camera"
  | "edit"
  | "check"
  | "checkbox"
  | "x"
  | "trash"
  | "user-x"
  | "logout"
  | "import"
  | "chevron"
  | "chevron-right"
  | "settings"
  | "menu"
  | "route"
  | "coin";

export interface IconProps extends SVGProps<SVGSVGElement> {
  name: IconName;
}

/**
 * Renders an icon from the inline sprite at the root of the document
 * (`<IconSprite />`). The width/height/color are inherited from the
 * surrounding CSS — match the existing `.nav-item__icon`, `.tab-bar__icon`
 * etc. styles for consistent sizing.
 */
export default function Icon({ name, ...rest }: IconProps) {
  return (
    <svg aria-hidden="true" {...rest}>
      <use href={`#icon-${name}`} />
    </svg>
  );
}
